module.exports = __webpack_public_path__ + "img/19-03.c33dcef9.png";